import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import "./Accueil.css";

import { Link } from "react-router-dom";

import Img1 from "../../assets/img/Accueil/Contact2-1.png";
import Img2 from "../../assets/img/Accueil/Contact2-2.png";
import Img3 from "../../assets/img/Accueil/Contact2-3.png";

gsap.registerPlugin(ScrollTrigger);

export default function Contact2() {
  const sectionRef = useRef(null);
  const { t } = useTranslation();

  const Fiches = [
    {
      id: "gfx-a",
      title: t("contact2.gfxTitle"),
      texte: t("contact2.gfxText1"),
      img: Img1,
    },
    {
      id: "gfx-b",
      title: t("contact2.gfxTitle"),
      texte: t("contact2.gfxText1"),
      img: Img1,
    },
    {
      id: "gfx-c",
      title: t("contact2.gfxTitle"),
      texte: t("contact2.gfxText2"),
      img: Img2,
    },
    {
      id: "gfx-d",
      title: t("contact2.gfxTitle"),
      texte: t("contact2.gfxText3"),
      img: Img3,
    },
    {
      id: "gfx-e",
      title: t("contact2.gfxTitle"),
      texte: t("contact2.gfxText3"),
      img: Img3,
    },
  ];

  useLayoutEffect(() => {
    let refresh;
    const ctx = gsap.context(() => {
      const cards = gsap.utils.toArray(".Accueil-Contact .Card");
      if (!cards.length) return;

      gsap.set(cards, { autoAlpha: 1, pointerEvents: "auto" });

      const tl = gsap.timeline({
        defaults: { ease: "none" },
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top top",
          end: `+=${(cards.length - 1.5) * 100}%`,
          pin: true,
          scrub: 1,
          markers: false,
          invalidateOnRefresh: true,
        },
      });

      cards.forEach((card, i) => {
        if (i === cards.length - 1) return;
        tl.to(card, { autoAlpha: 0, pointerEvents: "none", duration: 0.25 }, i);
      });

      refresh = () => ScrollTrigger.refresh();
      window.addEventListener("load", refresh);

      const imgs = sectionRef.current?.querySelectorAll("img") ?? [];
      imgs.forEach((img) => {
        if (!img.complete)
          img.addEventListener("load", refresh, { once: true });
      });
    }, sectionRef);

    return () => {
      ctx.revert();
      if (refresh) window.removeEventListener("load", refresh);
    };
  }, []);

  return (
    <div ref={sectionRef} className="Accueil-Contact Contact2">
      {Fiches.map((f, i) => (
        <div key={f.id} className="Card" id={`Card-${f.id}`} data-i={i}>
          <div className="Right">
            <img src={f.img} alt="" />
          </div>
          <div className="Left">
            <h3>{f.title}</h3>
            <p>{f.texte}</p>
            <Link to="/contact" className="websiteBtn">
              {t("contact2.button")}
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}
